import { Component, computed, input, OnInit, output, signal } from '@angular/core';
import { BannerComponent, CardComponent, SegmentHeaderComponent } from '@app/components';
import { TaxFormBox } from '@app/models/payroll/tax-form-box.abstract.model';
import { TaxForm } from '@app/models/payroll/tax-form.abstract.model';
import { TaxReturnService } from '@app/modules/payroll/services/tax-return.service';
import { TranslatableKey } from '@app/types/translatable.type';
import { TranslateModule } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';
import { EmployeeTaxFormBoxComponent } from './employee-tax-form-box.component';

@Component({
    selector: 'app-employee-tax-form-boxes',
    standalone: true,
    imports: [CardComponent, SegmentHeaderComponent, TranslateModule, BannerComponent, EmployeeTaxFormBoxComponent],
    styles: [
        `
            h3 {
                margin-top: 2rem;
            }
        `,
    ],
    templateUrl: './employee-tax-form-boxes.component.html',
})
export class EmployeeTaxFormBoxesComponent implements OnInit {
    /**
     * The taxForm (RL1 or T4)
     */
    taxForm = input.required<TaxForm>();

    /**
     * Outputs an event when the user clicks the "Edit" button
     */
    onEditBoxes = output<void>();

    boxes = signal<{ title?: TranslatableKey; boxes: TaxFormBox[] }[] | undefined>(undefined);

    /**
     * Whether the form contains any errors
     */
    hasErrors = computed(() => !!Object.keys(this.taxForm().errors).length);

    isLoading = true;

    /**
     * Is a RL1 or a T4
     */
    returnType = computed(() => (this.taxForm().isRL1() ? 'RL1' : 'T4'));

    constructor(private taxReturnService: TaxReturnService) {}

    async ngOnInit(): Promise<void> {
        this.taxReturnService
            .getBoxes(this.taxForm())
            .pipe(tap(() => (this.isLoading = false)))
            .subscribe(this.boxes.set);
    }
}
